module.exports = __webpack_public_path__ + "img/nextories-logo-vertical-rvb.svg";